import LIGHT_COLORS from 'theme/colors/light-colors';

const styles = {
  rootContainer: {
    display: 'flex',
  },
  titleText: {
    color: LIGHT_COLORS.textPrimaryWhite,
  },
};

export default styles;
